import { createStyles, makeStyles } from '@material-ui/core/styles';
import { PRIMARY, WHITE } from 'constants/colors';
export default makeStyles(theme => createStyles({
  badgeStep: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    textAlign: 'left',
    alignItems: 'center'
  },
  badge: {
    marginRight: theme.spacing(1),
    backgroundColor: PRIMARY,
    color: WHITE,
    borderRadius: '50%',
    width: '35px',
    minWidth: '35px',
    height: '35px',
    minHeight: '35px',
    display: 'flex',
    fontSize: '22px',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));